// extracted by mini-css-extract-plugin
module.exports = {"root":"Loading_root__aTnSK","spinner":"Loading_spinner__1MQzg","spinner3":"Loading_spinner3__2uOgL","rotation":"Loading_rotation__3gSD4"};